import {Resource} from "../../api/resource";
import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {Material} from "../materiales/material.model";
import {ColorMaterial} from "../materiales/color.model";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {Uri} from "../../api/uri";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {PropertyMap, ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {MetodoFabricacion} from "../materiales/metodo-fabricacion.model";
import {DireccionPersona} from "../personas/direccion-persona.model";
import {Proveedor} from "../personas/proveedor.model";
import {TipoMaterial} from "../materiales/tipo-material.model";
import {Trabajo} from "../trabajos/trabajo.model";
import {SubTrabajo} from "../trabajos/subtrabajo.model";
import {TarifaFabricacion} from "../tarifas/tarifa-fabricacion.model";
import {Solicitud} from "./solicitud.model";
import {LineaSolicitudOpcion} from "./linea-solicitud-opcion.model";
import {LineaSolicitudTornillo} from "./linea-solicitud-tornillo.model";
import {ArchivoSTL} from "../archivos/archivo-stl.model";
import {ExactSearchFilter} from "../../basic-entity-back/filters/search-filter";
import {IriSearchFilter} from "../../basic-entity-back/filters/iri-search-filter";
import {BaseEntity} from "../base-entity.model";
import {TipoConexion} from "../trabajos/tipo-conexion.model";
import {ArchivoSTLLineaSolicitud} from "../archivos/archivo-stl-linea-solicitud.model";
import {Marca} from "../almacen/marca.model";

@BasicEntity({
    name: 'Lineas Solicitud',
    endpoint: 'linea_solicituds',
    isPaginated: true
})
export class LineaSolicitud extends BaseEntity {

    @BasicProperty({
        isId: true,
        name: 'ID',
        type: PropertyType.Integer()
    })
    private _id: number;

    public static readonly MAP_SOLICITUD: PropertyMap = {
        name: 'Solicitud',
        type: PropertyType.FutureUri('solicitud.model.ts'),
        filters: [ExactSearchFilter, IriSearchFilter]
    }
    @BasicProperty(LineaSolicitud.MAP_SOLICITUD)
    private _solicitud;

    @BasicProperty({
        name: 'Código Paciente',
        type: PropertyType.String(3),
        nullable: false
    })
    private _codigoPaciente: string;

    @BasicProperty({
        name: 'Código Clínico (opcional)',
        type: PropertyType.String(),
        nullable: true
    })
    private _codigoClinico;

    @BasicProperty({
        name: 'Dientes',
        type: PropertyType.String()
    })
    private _dientes = '';

    @BasicProperty({
        name: 'Método',
        type: PropertyType.NestedModel(MetodoFabricacion, undefined, NestedBehavior.SendIriOnly)
    })
    private _metodoFabricacion: MetodoFabricacion;

    @BasicProperty({
        name: 'Material',
        type: PropertyType.NestedModel(Material, undefined, NestedBehavior.SendIriOnly)
    })
    private _material: Material;

    @BasicProperty({
        name: 'Acabado',
        type: PropertyType.NestedModel(TipoMaterial, undefined, NestedBehavior.SendIriOnly),
        nullable: true
    })
    private _acabado?: Material;

    @BasicProperty({
        name: 'Color',
        type: PropertyType.NestedModel(ColorMaterial, undefined, NestedBehavior.SendIriOnly),
        nullable: true
    })
    private _color: ColorMaterial;

    @BasicProperty({
        name: 'Dirección de entrega',
        type: PropertyType.Uri(DireccionPersona)
    })
    private _direccionEntrega: Uri;

    @BasicProperty({
        name: 'Transporte',
        type: PropertyType.Uri(Proveedor)
    })
    private _transporte: Uri;

    @BasicProperty({
        name: 'Tarifa aplicada',
        type: PropertyType.NestedModel(TarifaFabricacion, null, NestedBehavior.SendIriOnly)
    })
    private _tarifaAplicada;

    @BasicProperty({
        name: 'Trabajo',
        type: PropertyType.NestedModel(Trabajo, null, NestedBehavior.SendIriOnly)
    })
    private _trabajo;

    @BasicProperty({
        name: 'Trabajo',
        type: PropertyType.Object(),
        readWrite: ReadWrite.ReadOnly,
        array: true
    })
    private _trabajos = [];

    @BasicProperty({
        name: 'Subtrabajo',
        type: PropertyType.NestedModel(SubTrabajo, null, NestedBehavior.SendIriOnly)
    })
    private _subTrabajo;

    @BasicProperty({
        name: 'Subtrabajo obligado',
        type: PropertyType.NestedModel(SubTrabajo, null, NestedBehavior.SendIriOnly),
        nullable: true
    })
    private _subTrabajoObligado;

    @BasicProperty({
        name: 'Opciones',
        type: PropertyType.NestedModel(LineaSolicitudOpcion, null, NestedBehavior.CreateOnly),
        array: true,
        nullable: true
    })
    private _opciones = [];


    @BasicProperty({
        name: 'Incluir tornillería',
        type: PropertyType.Boolean()
    })
    private _incluirTornilleria = false;

    @BasicProperty({
        name: 'Tipo de conexión',
        type: PropertyType.NestedModel(Marca, undefined, NestedBehavior.SendIriOnly),
        nullable: true
    })
    private _tipoConexion: Marca | null;

    @BasicProperty({
        name: 'Datos extra del tipo de conexión',
        type: PropertyType.String(),
        nullable: true
    })
    private _datosExtraTipoConexion: string | null = '';

    @BasicProperty({
        name: 'Cantidad',
        type: PropertyType.Integer()
    })
    private _cantidad: number = 0;

    @BasicProperty({
        name: 'Cantidad Subtrabajo obligado',
        type: PropertyType.Integer()
    })
    private _cantidadSubTrabajoObligado: number = 0;

    @BasicProperty({
        name: 'Importe trabajos',
        type: PropertyType.Float()
    })
    private _importeTrabajos: number = 0;

    @BasicProperty({
        name: 'Importe trabajos (Sin descuento)',
        type: PropertyType.Float()
    })
    private _importeTrabajosSinDescuento: number = 0;

    @BasicProperty({
        name: 'Importe linea',
        type: PropertyType.Float()
    })
    private _importeTotal: number = 0;

    @BasicProperty({
        name: 'Importe linea (Sin descuento)',
        type: PropertyType.Float()
    })
    private _importeTotalSinDescuento: number = 0;

    @BasicProperty({
        name: 'Observaciones',
        nullable: true,
        type: PropertyType.Text()
    })
    private _observaciones: string;

    @BasicProperty({
        name: 'Estado',
        type: PropertyType.Text(),
        readWrite: ReadWrite.ReadOnly
    })
    private _estado: string;

    @BasicProperty({
        name: 'Tornilleria',
        type: PropertyType.NestedModel(LineaSolicitudTornillo, 'lineaSolicitud', NestedBehavior.CreateOnly),
        array: true,
        nullable: true
    })
    private _tornilleria = [];

    @BasicProperty({
        name: 'Archivo',
        type: PropertyType.NestedModel(ArchivoSTLLineaSolicitud, null, NestedBehavior.SendIriOnly),
        nullable: true
    })
    private _stlLineaSolicitud;

    @BasicProperty({
        name: 'Concepto',
        type: PropertyType.String(),
        readWrite: ReadWrite.ReadOnly
    })
    private _resumen = '';

    @BasicProperty({
        name: 'Es modelo',
        type: PropertyType.Boolean()
    })
    private _esModelo = false;

    @BasicProperty({
        name: 'Fabricación y material',
        type: PropertyType.Text()
    })
    private _metodoFabricacionMaterialTexto = '';

    @BasicProperty({
        name: 'Tipos de implante',
        type: PropertyType.Text()
    })
    private _tiposImplanteTexto = '';

    @BasicProperty({
        name: 'Fabricación de modelos',
        type: PropertyType.Text()
    })
    private _fabricacionModelosTexto = '';

    @BasicProperty({
        name: 'Información de librería digital utilizada y tipos de implante',
        type: PropertyType.Text()
    })
    private _informacionLibreriaDigitalTexto = '';

    @BasicProperty({
        name: 'Trabajos',
        type: PropertyType.String(),
        dontReadFromApi: true,
        readWrite: ReadWrite.ReadOnly
    })
    get trabajosString() {
        return this._trabajos.map(t => t[0] + '(' + t[1] + ')').join(',')
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get solicitud() {
        return this._solicitud;
    }

    set solicitud(value) {
        this._solicitud = value;
    }

    get codigoPaciente(): string {
        return this._codigoPaciente;
    }

    set codigoPaciente(value: string) {
        this._codigoPaciente = value;
    }

    get codigoClinico() {
        return this._codigoClinico;
    }

    set codigoClinico(value) {
        this._codigoClinico = value;
    }

    get metodoFabricacion(): MetodoFabricacion {
        return this._metodoFabricacion;
    }

    set metodoFabricacion(value: MetodoFabricacion) {
        this._metodoFabricacion = value;
    }

    get material(): Material {
        return this._material;
    }

    set material(value: Material) {
        this._material = value;
    }

    get color(): ColorMaterial {
        return this._color;
    }

    set color(value: ColorMaterial) {
        this._color = value;
    }

    get direccionEntrega() {
        return this._direccionEntrega;
    }

    set direccionEntrega(value) {
        this._direccionEntrega = value;
    }

    get transporte(): Uri {
        return this._transporte;
    }

    set transporte(value: Uri) {
        this._transporte = value;
    }

    get acabado(): Material {
        return this._acabado;
    }

    set acabado(value: Material) {
        this._acabado = value;
    }

    get tarifaAplicada() {
        return this._tarifaAplicada;
    }

    set tarifaAplicada(value) {
        this._tarifaAplicada = value;
    }

    get trabajo() {
        return this._trabajo;
    }

    set trabajo(value) {
        this._trabajo = value;
    }

    get subTrabajo() {
        return this._subTrabajo;
    }

    set subTrabajo(value) {
        this._subTrabajo = value;
    }

    get subTrabajoObligado() {
        return this._subTrabajoObligado;
    }

    set subTrabajoObligado(value) {
        this._subTrabajoObligado = value;
    }

    get opciones() {
        return this._opciones;
    }

    set opciones(value) {
        this._opciones = value;
    }

    get cantidad(): number {
        return this._cantidad;
    }

    get cantidadSubTrabajoObligado(): number {
        return this._cantidadSubTrabajoObligado;
    }

    set cantidadSubTrabajoObligado(value: number) {
        this._cantidadSubTrabajoObligado = value;
    }

    set cantidad(value: number) {
        this._cantidad = value;
    }

    get importeTrabajos(): number {
        return this._importeTrabajos;
    }

    set importeTrabajos(value: number) {
        this._importeTrabajos = value;
    }

    get importeTotal(): number {
        return this._importeTotal;
    }

    set importeTotal(value: number) {
        this._importeTotal = value;
    }

    get observaciones(): string {
        return this._observaciones;
    }

    set observaciones(value: string) {
        this._observaciones = value;
    }

    get estado(): string {
        return this._estado;
    }

    set estado(value: string) {
        this._estado = value;
    }

    get dientes(): string {
        return this._dientes;
    }

    set dientes(value: string) {
        this._dientes = value;
    }

    get tornilleria(): any[] {
        return this._tornilleria;
    }

    set tornilleria(value: any[]) {
        this._tornilleria = value;
    }

    get stlLineaSolicitud() {
        return this._stlLineaSolicitud;
    }

    set stlLineaSolicitud(value) {
        this._stlLineaSolicitud = value;
    }

    get trabajos(): any[] {
        return this._trabajos;
    }

    set trabajos(value: any[]) {
        this._trabajos = value;
    }

    get importeTrabajosSinDescuento(): number {
        return this._importeTrabajosSinDescuento;
    }

    set importeTrabajosSinDescuento(value: number) {
        this._importeTrabajosSinDescuento = value;
    }

    get importeTotalSinDescuento(): number {
        return this._importeTotalSinDescuento;
    }

    set importeTotalSinDescuento(value: number) {
        this._importeTotalSinDescuento = value;
    }

    get resumen(): string {
        return this._resumen;
    }

    set resumen(value: string) {
        this._resumen = value;
    }

    get tipoConexion(): Marca | null {
        return this._tipoConexion;
    }

    set tipoConexion(value: Marca | null) {
        this._tipoConexion = value;
    }

    get datosExtraTipoConexion(): string | null {
        return this._datosExtraTipoConexion;
    }

    set datosExtraTipoConexion(value: string | null) {
        this._datosExtraTipoConexion = value;
    }

    get esModelo(): boolean {
        return this._esModelo;
    }

    set esModelo(value: boolean) {
        this._esModelo = value;
    }

    get incluirTornilleria(): boolean {
        return this._incluirTornilleria;
    }

    set incluirTornilleria(value: boolean) {
        this._incluirTornilleria = value;
    }

    get metodoFabricacionMaterialTexto(): string {
        return this._metodoFabricacionMaterialTexto;
    }

    set metodoFabricacionMaterialTexto(value: string) {
        this._metodoFabricacionMaterialTexto = value;
    }

    get tiposImplanteTexto(): string {
        return this._tiposImplanteTexto;
    }

    set tiposImplanteTexto(value: string) {
        this._tiposImplanteTexto = value;
    }

    get fabricacionModelosTexto(): string {
        return this._fabricacionModelosTexto;
    }

    set fabricacionModelosTexto(value: string) {
        this._fabricacionModelosTexto = value;
    }

    get informacionLibreriaDigitalTexto(): string {
        return this._informacionLibreriaDigitalTexto;
    }

    set informacionLibreriaDigitalTexto(value: string) {
        this._informacionLibreriaDigitalTexto = value;
    }
}

LineaSolicitudOpcion.MAP_LINEA_SOLICITUD.type = PropertyType.Uri(LineaSolicitud)
LineaSolicitudTornillo.MAP_LINEA_SOLICITUD.type = PropertyType.Uri(LineaSolicitud)
ArchivoSTLLineaSolicitud.LINEA_SOLICITUD_MAP.type = PropertyType.Uri(LineaSolicitud)
